import home from 'assets/images/menu/homeIcon.svg';
import newHome from 'assets/images/menu/newHomeIcon.svg';
import newDoc from 'assets/images/menu/newDoqIcon.svg';
import newNudges from 'assets/images/menu/newNudgesIcon.svg';
import newMenu from 'assets/images/menu/newMenuIcon.svg';
import doc from 'assets/images/menu/docIcon.svg';
import reminder from 'assets/images/menu/reminderIcon.svg';
import menu from 'assets/images/menu/menuIcon.svg';

import identity from 'assets/images/categories/identity.svg';
import bank from 'assets/images/categories/bank.svg';
import education from 'assets/images/categories/education.svg';
import family from 'assets/images/categories/family.svg';
import pension from 'assets/images/categories/pension.svg';
import medical from 'assets/images/categories/medical.svg';

export const defaultDashboardCategory = [
  {
    id: 1,
    name: 'Bank',
    image: bank,
    dataCy: 'bank',
    url: '#',
    documents_count: 0,
    slug: 'bank',
  },
  {
    id: 2,
    name: 'Education',
    image: education,
    dataCy: 'education',
    url: '#',
    documents_count: 0,
    slug: 'education',
  }, {
    id: 3,
    name: 'Family',
    image: family,
    dataCy: 'family',
    url: '#',
    documents_count: 0,
    slug: 'family',
  },
  {
    id: 4,
    name: 'Identity',
    image: identity,
    dataCy: 'identity',
    url: '#',
    documents_count: 0,
    slug: 'identity',
  },

  {
    id: 5,
    name: 'Health',
    image: medical,
    dataCy: 'medical',
    url: '#',
    documents_count: 0,
    slug: 'medical',
  },
  {
    id: 6,
    name: 'Pension',
    image: pension,
    dataCy: 'pension',
    url: '#',
    documents_count: 0,
    slug: 'pension',
  },
];

export const menuItems = [
  {
    id: 1,
    title: 'HOME',
    imageUrl: newHome,
    isActive: false,
    dataCy: 'cta-home',
    url: '/dashboard',
  },
  {
    id: 2,
    title: 'SHARING',
    imageUrl: newDoc,
    isActive: false,
    dataCy: 'cta-sharing',
    url: '/sharing-tab',
  },
  {
    id: 3,
    title: '',
    imageUrl: '',
    dataCy: '',
    isActive: false,
  },
  {
    id: 4,
    title: 'NUDGES',
    imageUrl: newNudges,
    isActive: false,
    dataCy: 'cta-reminder',
    url: '/reminders',
  },
  {
    id: 5,
    title: 'SETTINGS',
    imageUrl: newMenu,
    isActive: false,
    dataCy: 'cta-settings',
    url: '/menu',
  },
];
